__turbopack_context__.v({
  "card": "Card-module-scss-module__LbGBxa__card",
  "card-overflow-hidden": "Card-module-scss-module__LbGBxa__card-overflow-hidden",
  "isOutlined": "Card-module-scss-module__LbGBxa__isOutlined",
});
